module.exports = __webpack_public_path__ + "img/filtericon.62262a0d.svg";